module.exports = __webpack_public_path__ + "static/helloworlddiscmain-41621958b5c7f74c29d5d5c559071097.jpeg";